const zh = {
  header: {
    tip1:
      "为了防止系统误关闭您的虚拟空间中正在进行的游戏，导致您的游戏在未知情况下被掉线中断，需要您手动按照以下步骤完成设置。",
  },
  content: {
    list1: {
      title: "将虚拟大师添加【锁定】，保存后台运行。",
    },
    list2: {
      title: "打开手机设置-搜索【应用启动管理】",
    },
    list3: {
      title: "搜索虚拟大师，开启允许自启动，开启允许后台活动。",
    },
  },
};

export default zh;
